/** Класс изменения иконки у поля пароля. */
class PasswordIcon {
    /**
     * Конструктор класса.
     *
     */
    constructor(icon) {
        this.icon = icon;
        this.input = this.icon.closest(".input-wrap").querySelector("input[type='password'");
        this.iconUse = this.icon.querySelector("use");
        this.iconHref = this.iconUse.dataset.password;
        this.iconTextHref = this.iconUse.dataset.text;
        this.icon.addEventListener("click", this.showPassword.bind(this));
    }

    /**
     * Прослушиваем события в инпуте.
     *
     * @returns {void}
     */
    bindEventListeners() {
        super.bindEventListeners();
    }

    /**
     * Действия при вводе пароля.
     *
     * @param {Event} e Событие, происходящее при вводе в инпуте.
     * @returns {void}
     */
    onInput() {
        super.onInput();
    }

    /**
     * Показать пароль.
     *
     * @param {Event} e Событие, происходящее при клике.
     * @returns {void}
     */
    showPassword(e) {
        e.preventDefault();
        if (this.input.type === "text") {
            this.input.type = "password";
            this.input.dataset.type = "";
            if (this.iconUse) {
                this.iconUse.setAttribute("href", this.iconHref);
            }
        } else {
            this.input.type = "text";
            this.input.dataset.type = "password";
            if (this.iconUse) {
                this.iconUse.setAttribute("href", this.iconTextHref);
            }
        }
    }
}

document
    .querySelectorAll(".js-password-icon")
    .forEach(icon => new PasswordIcon(icon));